import application from "stimulus_application";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import "vanilla-calendar-pro/styles/layout.css";
import "./standalone_calendar.css";

const context = require.context("./", true, /_controller\.js$/);
application.load(definitionsFromContext(context));
